import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import { Doughnut } from 'react-chartjs-2';

import { isEmpty } from 'lodash';
// import {Chart, ArcElement} from 'chart.js';
// import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';

import useTranslateText from '../use_translate_text';
import useWindowDimensions from '../use_Window_Dimensions';
import './circular_charts.scss';
// import { left } from '@patternfly/react-core/dist/js/helpers/Popper/thirdparty/popper-core';

const CircularCharts = (props) => {
  // const { chart, className, chartheading, id, marginTop, marginLeft, cheight, cwidth, direction,
  //         isLast, showLabel = true } = props,
  const { chart, className, chartheading, marginTop, marginLeft, cheight, cwidth,
          isLast, showLabel = true } = props,
        { datasets, totalKey, amountTotal } = chart || {};





  if (isEmpty(datasets)) return <span />;
  const { translateText } = useTranslateText();
  const [_isMounted, _setIsMounted] = useState(true);
  const [chartData, setChartData] = useState({ });
  const { width } = useWindowDimensions();
  chart.datasets[0].backgroundColor = [
    '#69EDFC',
    '#FFC664',
    '#F54FBE',
    '#56C3DF',
    '#99FBC3',
    '#FE898A',
    '#5EC733',
    '#EBFD6F',
    '#A646CE',
    '#78F6FF',
    '#4E95FF',
    '#30B6C5',
    '#7E7BE8',
    '#BB63AF',
    '#78E1B9',
    '#26B99A',
    '#81A7BB',
    '#A4B2F5',
    '#EB9937',
    '#3E6B7B',
    '#3F3F40',
    '#7C96A8',
    '#4B4A4A',
    '#949494',
    '#688798',
    '#284A5D',
    '#105F93',
    '#30B6C5',
    '#7E7BE8',
    '#BB63AF',
    '#78E1B9',
    '#26B99A',
    '#81A7BB',
    '#A4B2F5',
    '#EB9937',
    '#3E6B7B',
    '#3F3F40',
    '#7C96A8',
    '#4B4A4A',
    '#949494',
    '#688798',
    '#284A5D',
    '#105F93',
  ];

  useEffect(() => {
    if (_isMounted && !isEmpty(chart)) {
      if (chart?.labels?.length > 14 && !isLast) {
        const chartLabelData = [];
        chart.labels.map((item) => {
          // if (index < 16) {
          return chartLabelData.push(item);
          // }
          // else return false;
        });
        setChartData({ ...chart, labels: chartLabelData });
        // setIsMore(true);
      }
      else if (chart?.labels?.length > 14 && isLast) {
        const chartLabelData = [];
        chart.labels.map((item) => {
          // if (index < 13) {
          return chartLabelData.push(item);
          // }
          // else return false;
        });
        setChartData({ ...chart, labels: chartLabelData });

        // setIsMore(true);
      }
      else {
        setChartData({ ...chart });
      }
    }

    return () => {
      _setIsMounted(false);
    };
  }, []);


  ChartJS.register(ArcElement, Tooltip, Legend);

  const optionsfromDashboard = {
    cutoutPercentage: 80,
    responsive: false,
    aspectRatio: 1,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        maxHeight: 10,
        maxWidth: 200,
      },
      tooltip: {
        callbacks: {
          label: (args) => {
            return args.label;
          },
        },
      },
    },
  };
  const options = {
    cutoutPercentage: 70,
    responsive: false,
    aspectRatio: 1,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: 'right',
        maxHeight: 10,
        maxWidth: 200,
      },
      tooltip: {
        callbacks: {
          label: (args) => {
            return args.label;
          },
        },
      },
    },
  };

  return (
    <> {!isEmpty(chartData) &&
    <div className="circular-chart">
      {chartheading && <p className="circular-charts__heading">{chartheading}</p>}
      {totalKey && amountTotal && width > 574 &&
        <p className= {`circular-charts__total ${className}`} style={{ marginTop: marginTop || 100, marginLeft: marginLeft || 50 }}>
          {translateText(totalKey)}
          <span className="circular-charts__total-amount">${amountTotal}</span>
        </p>
      }
      <Doughnut
        data={chartData}
        //  options={optionsd}
        // id={id}
        // data={ddata}
        width = {cwidth || 250}
        height={cheight || 250}
        options= {(!showLabel && chart?.labels?.length > 14) ? options : optionsfromDashboard}
      />
      {totalKey && amountTotal && width < 574 && <>
        <hr></hr>
        <p className= "circular-charts__total circular-charts__total--mobile">
          {translateText(totalKey)}
          <span className="circular-charts__total-amount">${amountTotal}</span>
        </p>
        <hr></hr>
      </>
      }

    </div>

    }
    </>

  );
};

export default CircularCharts;

